import styled, { css, screenMobilePlusAndSmaller } from 'theme';

export const HideOnMobile = styled('span')`
  display: initial;

  ${screenMobilePlusAndSmaller(css`
    display: none;
  `)}
`;
